import React from 'react';
import styles from './styles.module.scss';

function Content({ ...others }) {
  return <div className={styles.content} {...others} />;
}

export default Content;
